import { AllLeaguesRetriever } from "../AllLeaguesRetriever";
import { CouponLeaguesRetriever } from "../CouponLeaguesRetriever";
import { TopLeaguesRetriever } from "../TopLeaguesRetriever";
export class RetrieverFactory {
    constructor(meta, dataProvider, loadData, addData, changeData, deleteData) {
        this.meta = meta;
        this.dataProvider = dataProvider;
        this.loadData = loadData;
        this.addData = addData;
        this.changeData = changeData;
        this.deleteData = deleteData;
    }
    createRetriever(sportId = "0", leagueIds = []) {
        this.dataProvider.sportId = sportId;
        this.dataProvider.leagueIds = leagueIds;
        if (this.dataProvider.leagueIds.length) {
            return new CouponLeaguesRetriever(this.meta, this.dataProvider, this.loadData, this.addData, this.changeData, this.deleteData);
        }
        if (this.dataProvider.isTopLeaguesOnly) {
            return new TopLeaguesRetriever(this.meta, this.dataProvider, this.loadData, this.addData, this.changeData, this.deleteData);
        }
        return new AllLeaguesRetriever(this.meta, this.dataProvider, this.loadData, this.addData, this.changeData, this.deleteData);
    }
}
//# sourceMappingURL=RetrieverFactory.js.map